import { useState } from "react";
import "./fixed-header-mobile.css";
import { Container, Row } from "react-bootstrap";
import React, { useContext } from "react";
import { UserContext } from "../App";

export const FixedHeaderMobile = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const data = useContext(UserContext);
  const menuItems = [];

  const section = data.sections;

  if(section.project_section){
    menuItems.push(<a href="#projects" key={section.type}>Projects</a>);
  } 
  if(section.media_sec ){
    menuItems.push(<a href="#media" key={section.type}>Media</a>);
  } 
  if(section.experience_section ){
    menuItems.push(<a href="#experiance" key={section.type}>Experience</a>);
  }
  if(section.education_sec){
    menuItems.push(<a href="#education" key={section.type}>Education</a>);
  }
  if(section.awards_section){
    menuItems.push(<a href="#awards" key={section.type}>Awards</a>);
  }
  if(section.testimonial_section ){
    menuItems.push(<a href="#testimonials" key={section.type}>Testimonials</a>);
  }

  return (
    <div className="fixed-header-mobile">
      <div className="menu-holder" onClick={() => setMenuOpen(!menuOpen)}>
        <i className="fa-solid fa-bars"></i>
      </div>

      <div
        className={`backdrop ${menuOpen && "visible"}`}
        onClick={() => setMenuOpen(false)}
      />

      <div className={`menu-wrapper ${menuOpen && "visible"}`}>
        <div className="fixed-header-mobile-container" onClick={() => setMenuOpen(false)}>
          <a href="#about">About</a>
          {menuItems}
        </div>
      </div>
    </div>
  );
};
